// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3xLWW","ranges":"BmiRanges_ranges__3yRGr"};